import dayjs from "dayjs";
import { monthNameArr } from "../Mycomponent/share/upDater/constant";
import i18next from "i18next";

export const domainRegex =
  /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:\d+)?(\/\S*)?$/;

export const isValidEmail = (input) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(input);
};

export const extractDomain = (url) => {
  const match = url.match(/^(?:https?:\/\/)?(?:www\.)?([^/]+)/i);
  return match ? match[1].replace(/\s/g, "") : ""; // Remove protocol and get domain
};

export const checkIfAdmin = (email) => {
  const isAdmin = [
    "alekh@rankspro.io",
    "singhashish1.sh@gmail.com",
    "ravi@rankspro.io",
  ];
  return isAdmin.includes(email);
};

export function makeUnique(array) {
  if (array?.length === 0) return [];
  return array?.filter(
    (value, index, self) =>
      index ===
      self.findIndex((obj) => obj.location_name === value.location_name)
  );
}

export const addLocationToData = (arrayA, location) => {
  if (arrayA?.length === 0) return [];
  return arrayA?.map((item) => {
    return {
      ...item,
      location,
    };
  });
};

export const addLocationToCompetitors = (arrayA, location) => {
  if (arrayA?.length === 0) return [];
  return {
    competitor: arrayA?.[0]?.competitor,
    comp_data: arrayA?.[0]?.comp_data?.map((item) => {
      return {
        ...item,
        location,
      };
    }),
  };
};

export const isTuesdayOrThursday = (date = new Date()) => {
  const day = date.getDay(); // 0 = Sunday, 1 = Monday, ..., 6 = Saturday
  // return day === 1 || day === 2 || day === 4; // 1 = monday, 2 = Tuesday, 4 = Thursday
  return day === 2 || day === 4; // 2 = Tuesday, 4 = Thursday
};

export const combineArraysForSameCompetitor = (data) => {
  const combinedData = [];
  data.forEach((entry) => {
    const existingEntry = combinedData.find(
      (combinedEntry) => combinedEntry.competitor === entry.competitor
    );

    if (existingEntry) {
      // Combine the comp_data arrays for the same competitor
      existingEntry.comp_data = existingEntry.comp_data.concat(entry.comp_data);
    } else {
      // Add a new entry if the competitor is not found
      combinedData.push({
        competitor: entry.competitor,
        comp_data: entry.comp_data,
      });
    }
  });

  return combinedData;
};

export const roundSpeedData = (value, precision) => {
  var multiplier = Math.pow(10, precision || 0);
  return Math.round(value * multiplier) / multiplier;
};

export const millisToSeconds = (milliseconds) => {
  const number = milliseconds / 1000;
  return parseFloat(number.toFixed(2));
};

export const calculatePercentage = (milliseconds) => {
  const number = millisToSeconds(milliseconds);
  if (number <= 0) {
    return 0;
  } else if (number <= 3) {
    return 18;
  } else if (number <= 5) {
    return 45;
  } else {
    return 80;
  }
};

export const sumQuesBasedKeyword = (array) => {
  if (array?.length === 0) return 0;
  let sum = 0;
  array.forEach((obj) => {
    if (obj?.searches) {
      const num = parseFloat(obj?.searches?.replace(/,/g, ""));
      sum += Number(num);
    }
  });
  if (sum >= 1000) {
    return (sum / 1000).toFixed(2) + "k"; // Use toFixed to round to 2 decimal places
  }
  return sum;
};

export function kFormatter(num) {
  return Math.abs(num) > 999
    ? Math.sign(num) * (Math.abs(num) / 1000).toFixed(1) + "K"
    : Math.sign(num) * Math.abs(num);
}

export const getDayAfter7Days = () => {
  const today = new Date();
  today.setDate(today.getDate() + 7); // Add 7 days
  return today.getDate().toString(); // Get the day of the month (1-31)
};

export function formatNumberWithSymbols(number) {
  number = Number(number);
  if (isNaN(number) || number === undefined) {
    return "0";
  } else if (number < 1000) {
    return Number(number.toFixed(2)); // No need for symbols if number is less than 1000
  }

  const symbols = ["", "K", "M", "B", "T"]; // Define symbols for thousands, millions, billions, trillions, etc.
  const magnitude = Math.floor(Math.log10(number) / 3); // Calculate the magnitude of the number
  let value = (number / Math.pow(10, magnitude * 3)).toFixed(2); // Calculate the value to display
  // Remove trailing zeros and unnecessary decimal point
  value = parseFloat(value).toString();
  return value + symbols[magnitude]; // Append the symbol
}

export function formatNumberWithSymbolsNoDecimal(number) {
  number = Number(number);
  if (isNaN(number) || number === undefined) {
    return "0";
  }

  const absNumber = Math.abs(number); // Work with the absolute value of the number
  if (absNumber < 1000) {
    return Number(number.toFixed(2)); // No need for symbols if the absolute value is less than 1000
  }

  const symbols = ["", "K", "M", "B", "T"]; // Define symbols for thousands, millions, billions, trillions, etc.
  const magnitude = Math.floor(Math.log10(absNumber) / 3); // Calculate the magnitude of the number
  // Calculate the value to display and append the symbol
  const value = (absNumber / Math.pow(10, magnitude * 3)).toFixed(0);
  const symbol = symbols[magnitude];
  const formattedValue = value + symbol;

  // Return the formatted value with the correct sign
  return number < 0 ? `-${formattedValue}` : formattedValue;
}

export function removeUndefinedAndNaN(arr) {
  return arr.filter((item) => typeof item !== "undefined" && !isNaN(item));
}

export function getOldestObject(objects) {
  // Initialize variables to hold the oldest date
  let oldestDate = new Date();
  let oldestObject = null;

  // Loop through each object
  for (let i = 0; i < objects.length; i++) {
    const object = objects[i];

    // Extract date, month, and year from the object
    const date = parseInt(object.date);
    const month = object.month;
    const year = parseInt(object.year);

    // Create a Date object from the extracted values
    const currentDate = new Date(year, monthToIndex(month), date);

    // Compare with the oldest date found so far
    if (currentDate < oldestDate) {
      oldestDate = currentDate;
      oldestObject = object;
    }
  }

  return oldestObject;
}

export const stringToBoolean = (str) => {
  if (typeof str === "string") {
    return str.toLowerCase() === "true";
  }
  return Boolean(str);
};

// Helper function to convert month name to index
function monthToIndex(month) {
  return monthNameArr.indexOf(month);
}

export function addCommasToNumber(number) {
  return number?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export function handleNaNAndUndefined(value) {
  if (isNaN(value)) {
    return true;
  } else if (value === undefined) {
    return true;
  } else {
    return false;
  }
}

export const validatePassword = (password) => {
  const minLength = 8;
  const maxLength = 16;
  const uppercasePattern = /[A-Z]/;
  const lowercasePattern = /[a-z]/;
  const numberPattern = /\d/;
  const specialCharPattern = /[!@#$%^&*(),.?":{}|<>]/;

  if (password.length < minLength || password.length > maxLength) {
    return i18next.t("auth.register.form.password.validation.between_min_max", {
      min: minLength,
      max: maxLength,
    });
  }
  if (!uppercasePattern.test(password)) {
    return i18next.t("auth.register.form.password.validation.uppercase");
  }
  if (!lowercasePattern.test(password)) {
    return i18next.t("auth.register.form.password.validation.lowercase");
  }
  if (!numberPattern.test(password)) {
    return i18next.t("auth.register.form.password.validation.number");
  }
  if (!specialCharPattern.test(password)) {
    return i18next.t(
      "auth.register.form.password.validation.special_character"
    );
  }
  return "";
};

export const getStatusCodeColor = (code) => {
  if (code >= 200 && code < 300) {
    return { color: "#075E45", backgroundColor: "#EBF7ED" };
  } else if ((code >= 100 && code < 200) || (code >= 300 && code < 400)) {
    return { color: "white", backgroundColor: "#F3A344" };
  } else if (code >= 400 && code < 600) {
    return { color: "#FF0000E5", backgroundColor: "#F9D1D199" };
  } else {
    return { color: "#961574", backgroundColor: "#FCF0F8" }; // Default color for unexpected codes
  }
};

export function dynamicSort(array, key, order = "asc") {
  return array?.sort((a, b) => {
    if (a[key] < b[key]) {
      return order === "asc" ? -1 : 1;
    }
    if (a[key] > b[key]) {
      return order === "asc" ? 1 : -1;
    }
    return 0;
  });
}

export const convertToObjects = (data) => {
  return (
    data?.flatMap((item) =>
      Object.entries(item).map(([key, value]) => ({
        domain: key,
        data: value,
      }))
    ) || []
  );
};

const removeDuplicateKeywords = (arr) => {
  return [...new Set(arr)];
};

export const uniqueByTextAndKeyword = (arr) => {
  const uniqueMap = new Map();

  arr?.forEach((item) => {
    const cleanedKeywords = removeDuplicateKeywords(item.keyword)
      .sort()
      .join(",");
    const key = `${item.text}-${cleanedKeywords}`;
    if (!uniqueMap.has(key)) {
      uniqueMap.set(key, {
        ...item,
        keyword: removeDuplicateKeywords(item.keyword),
      });
    }
  });

  return Array.from(uniqueMap.values());
};

export function incrementNumber() {
  return new Promise((resolve) => {
    let number = 0;
    const interval = setInterval(() => {
      number += 1;
      if (number > 5) {
        clearInterval(interval); // Stop the interval once number exceeds 5
        resolve(number); // Resolve the promise with the final value
      }
    }, 20000); // 20000 milliseconds = 20 seconds
  });
}

export function categorizeByLocationType(data) {
  return data?.reduce((acc, item) => {
    const type = item?.location_type;

    if (!acc[type]) {
      acc[type] = [];
    }

    acc[type].push(item);
    return acc;
  }, {});
}

export const rangeCircleStyle = (val, ranges) => {
  const defaultRange = ranges?.find((range) => range.default);
  for (const range of ranges) {
    const { min, max, backgroundColor } = range;
    if (min <= val && val <= max) {
      return {
        backgroundColor: backgroundColor,
        display: "inline-flex",
        justifyContent: "center",
        alignItems: "center",
        width: "10px",
        height: "10px",
        color: "rgba(255, 255, 255, 1)",
        borderRadius: "100%",
      };
    }
  }
  // Use the default color from ranges if defined
  return {
    backgroundColor: defaultRange?.backgroundColor
      ? defaultRange?.backgroundColor
      : "transparent",
    display: "inline-flex",
    justifyContent: "center",
    alignItems: "center",
    width: "36px",
    height: "36px",
    color: "rgba(255, 255, 255, 1)",
    borderRadius: "100%",
  };
};

export const diffStyle = (val) => {
  if (val <= 25) {
    return {
      backgroundColor: "rgb(108 170 106)",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      width: "10px",
      height: "10px",
      color: "rgba(255, 255, 255, 1)",
      borderRadius: "100%",
    };
  } else if (25 < val && val <= 50) {
    return {
      backgroundColor: "rgb(108 170 106)",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      width: "10px",
      height: "10px",
      color: "rgba(255, 255, 255, 1)",
      borderRadius: "100%",
    };
  } else if (50 < val && val <= 75) {
    return {
      backgroundColor: "rgba(255, 142, 59, 1)",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      width: "10px",
      height: "10px",
      color: "rgba(255, 255, 255, 1)",
      borderRadius: "100%",
    };
  } else {
    return {
      backgroundColor: "rgba(233, 86, 85, 1)",
      display: "inline-flex",
      justifyContent: "center",
      alignItems: "center",
      width: "10px",
      height: "10px",
      color: "rgba(255, 255, 255, 1)",
      borderRadius: "100%",
    };
  }
};

export const handleInvitedUserAccess = (feature, data) => {
  const siteOverview = data?.find((item) => item.hasOwnProperty(feature));
  const checkSiteOverviewAccess = siteOverview
    ? siteOverview[feature] === "True"
    : true;
  return checkSiteOverviewAccess;
};

export const handleInvitedUserProject = (status, data) => {
  if (data?.length === 0 || !data) return [];
  const excludeKeys = [
    "siteaudit",
    "addproject",
    "keywordresearch",
    "siteoverview",
    "backlinks",
    "backlinksgap",
  ];

  const projectKeys = data
    ?.filter((item) => {
      const [key, value] = Object.entries(item)[0];
      // Exclude if value is "False" or key is in excludeKeys array
      return value === status && !excludeKeys.includes(key);
    })
    .map((item) => Object.keys(item)[0]);

  return projectKeys;
};
// Function to map month string to number
const monthMap = {
  Jan: "01",
  Feb: "02",
  Mar: "03",
  Apr: "04",
  May: "05",
  Jun: "06",
  Jul: "07",
  Aug: "08",
  Sep: "09",
  Oct: "10",
  Nov: "11",
  Dec: "12",
};

export const filterAndSortData = (data, from, to) => {
  return data
    .filter((item) => {
      const itemDate = dayjs(
        `${item.year}-${monthMap[item.month]}-${item.date}`
      );
      // Manually check the conditions for including 'from' and 'to'
      return (
        (itemDate.isAfter(from, "day") || itemDate.isSame(from, "day")) &&
        (itemDate.isBefore(to, "day") || itemDate.isSame(to, "day"))
      );
    })
    .sort((a, b) => {
      const dateA = dayjs(`${a.year}-${monthMap[a.month]}-${a.date}`);
      const dateB = dayjs(`${b.year}-${monthMap[b.month]}-${b.date}`);
      return dateA - dateB;
    });
};

// Helper function to find an object by date, month, and year
export const findByFormattedDate = (array, formattedDate) => {
  const [day, month, year] = formattedDate.split(" ");
  // return array?.find(
  //   (item) => item.date === day && item.month === month && item.year === year
  // );

  // Find the item that matches the date, month, and year
  const foundItem = array?.find(
    (item) => item.date === day && item.month === month && item.year === year
  );

  // If foundItem is undefined, return an empty array instead
  return foundItem ? foundItem : [];
};

// Function to filter out undefined from an array
export const filterUndefinedFromArray = (array) => {
  return array.filter((item) => item !== undefined);
};

export function isDateDiffDaysOld(dateString, daysDifference) {
  // Parse the input date using the dayjs library with the format 'D-MMM-YYYY'
  const inputDate = dayjs(dateString, "D-MMM-YYYY");
  // Check if the date is valid
  if (!inputDate.isValid()) {
    return false; // Return false if the date is not valid
  }
  // Calculate the difference in days from today
  const today = dayjs();
  const differenceInDays = today.diff(inputDate, "day");
  // Check if the difference is 7 days or more
  return differenceInDays >= daysDifference;
}

export const free_plan = {
  plan_name: "Free",
  limit: 0,
  article: 2,
  meta: 3,
};

export const adminPlan = {
  plan_name: "Admin",
  limit: 120000,
  article: 1000,
  meta: 1000,
};

export const productIdForAi = [
  {
    product_id: "prod_RD01V9xgnahPqW",
    plan_name: "subscribe",
    plan: "pro",
    limit: 30000,
  },
  {
    product_id: "prod_RD02B4A2dP0miI",
    plan_name: "subscribe",
    plan: "elite",
    limit: 125000,
  },
  {
    product_id: "prod_RD03tHG1Mwnfl9",
    plan_name: "subscribe",
    plan: "ultimate",
    limit: 600000,
  },
];

export function stringToColor(string) {
  if (!string || string?.length === 0) return;
  let hash = 0;
  let i;
  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export const getSingleChar = (str) => {
  if (str && str.length > 0) {
    return str.charAt(0);
  }
  return null; // Return null if the string is empty or undefined
};

export const volTrendKeyIdeas = (val) => {
  if (val > 50) {
    return {
      backgroundColor: "rgb(108 170 106)", // green
    };
  } else if (0 < val && val <= 50) {
    return {
      backgroundColor: "rgba(255, 142, 59, 1)", // orange
    };
  } else {
    return {
      backgroundColor: "rgba(233, 86, 85, 1)", // red
    };
  }
};

export const diffStyleKeyIdeas = (val) => {
  if (val <= 50) {
    return {
      backgroundColor: "rgb(108 170 106)", // green
    };
  } else if (50 < val && val <= 75) {
    return {
      backgroundColor: "rgba(255, 142, 59, 1)", // orange
    };
  } else {
    return {
      backgroundColor: "rgba(233, 86, 85, 1)", // red
    };
  }
};

export function getBestAndWorstRank(rankArray, dateArray) {
  if (rankArray.length !== dateArray.length) {
    return {
      bestRank: null,
      bestRankDates: null,
      worstRank: null,
      worstRankDates: null,
    };
  }

  // Find the best rank (minimum) and worst rank (maximum)
  const bestRank = Math.min(...rankArray);
  const worstRank = Math.max(...rankArray);

  // Find the indices for the best and worst ranks
  const bestRankIndices = rankArray
    .map((rank, index) => (rank === bestRank ? index : -1))
    .filter((index) => index !== -1);

  const worstRankIndices = rankArray
    .map((rank, index) => (rank === worstRank ? index : -1))
    .filter((index) => index !== -1);

  // Map indices to corresponding dates
  const bestRankDates = bestRankIndices.map((index) => dateArray[index]);
  const worstRankDates = worstRankIndices.map((index) => dateArray[index]);

  return {
    bestRank,
    bestRankDates: bestRankDates?.[0],
    worstRank,
    worstRankDates: worstRankDates?.[0],
  };
}
